import { GET_CRITERIA_TAB, SET_CRITERIA_VALUES, CLEAR_CRITERIA_VALUES} from './types'
const initialState = {
    criteriaTab: {
        documentID: 0,
        schemaVersion: ''
        
    },
    criteriaValues: null,
   
};

const codexportReducer = (state = initialState, { type, payload }) => {
    switch (type) {
        case GET_CRITERIA_TAB:
            return {
                ...state,
                criteriaTab: {
                    ...state.criteriaTab, [payload['id']]: payload['value']
                }
            };
        case SET_CRITERIA_VALUES:
            return {
                ...state,
                criteriaValues: payload
            };
        case CLEAR_CRITERIA_VALUES:
            return {
                ...state,
                criteriaValues: null
            };
       
        default:
            return state;
    }
};

export default codexportReducer;